<div class="grid">
	<div class="col-12">					
		<div class="card">
		<p-divider></p-divider>
			<h5>Plano de Contas da Empresa</h5>
			<div *ngIf="messagemVisivel" class="field col-12 md:col-12">
				<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
			</div>
			<p-table #dt1 [value]="planosContaEmpresa" dataKey="id" [rows]="10" [loading]="loading" [rowHover]="true" 
			styleClass="p-datatable-gridlines" [paginator]="true" 
			[globalFilterFields]="['descricao', 'planoContaGrupo.descricao', 'dre']" 
			responsiveLayout="scroll" styleClass=" p-datatable-sm">			
			<ng-template pTemplate="caption">
				<div class="flex justify-content-between flex-column sm:flex-row">
					<div></div>
					<div>
						<span class="p-input-icon-left">
							<i class="pi pi-search"></i>
							<input pInputText type="text" #filter (input)="buscar(dt1, $event)" placeholder="Buscar"
								class="w-full" />
						</span>
						<span class="ml-2">
							<button pButton class="p-button-outlined" icon="pi pi-filter-slash"
								pTooltip="Limpar Filtros" (click)="limpar(dt1)"></button>
						</span>
					</div>
				</div>
			</ng-template>
                <ng-template pTemplate="header">
					<tr>
                        <th pSortableColumn="descricao">
							Descrição da Conta
							<p-sortIcon field="descricao">
							</p-sortIcon>
						</th>
						<th pSortableColumn="planoContaGrupo.descricao">
							Grupo
							<p-sortIcon field="planoContaGrupo.descricao">
							</p-sortIcon>
						</th>
						<th pSortableColumn="dre">
							DRE
							<p-sortIcon field="dre">
							</p-sortIcon>
						</th>
						<th pSortableColumn="status">
							Status
							<p-sortIcon field="status">
							</p-sortIcon>
						</th>
                        
                        <th>
							<div>
								Ações								
							</div>
						</th>	
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-item>
					<tr>
                        <td>
							{{item.descricao}}
						</td>
                        <td>
							{{item.planoContaGrupo.descricao}}
						</td>
						<td>
							{{item.dre}}
						</td>	
						<td>
							<span class="product-badge status-instock" *ngIf="item.ativo">ATIVO</span>
							<span class="product-badge status-outofstock" *ngIf="!item.ativo">INATIVO</span>
						</td>			
													
                        <td>
                            <button pButton pRipple pTooltip="Detalhar" icon="pi pi-eye" class="p-button-info mr-2 mb-2"
							(click)="detalhar(item.id)"></button>			
                            <button pButton pRipple pTooltip="Editar" icon="pi pi-pencil" class="p-button-success mr-2 mb-2"
							(click)="editar(item.id)" *ngIf="!modoDetalhar"></button>	
                            <button pButton pRipple pTooltip="Excluir" icon="pi pi-trash" class="p-button-danger mr-2 mb-2 sm"
							(click)="excluir(item.id)" *ngIf="!modoDetalhar"></button>	
                        </td>
                        
					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="7">Nenhum registro encontrado.</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="loadingbody">
					<tr>
						<td colspan="7">Carregando grupos. Por favor aguarde.</td>
					</tr>
				</ng-template>
    		</p-table>
		</div>
    </div>
</div>